import React from "react";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { GitBranch } from "lucide-react";

function EyeFormula({ side, data }) {
  if (!data) return null;
  const sel = data.formula_selection;
  return (
    <div className="rounded-lg border border-slate-200 bg-white p-4">
      <div className="flex items-center justify-between mb-2">
        <div className="text-[11px] uppercase tracking-wider text-slate-500 font-semibold">
          {side} · Selected formula
        </div>
        <Badge variant="secondary" className="font-mono text-xs">
          {sel.category.replace(/_/g, " ")}
        </Badge>
      </div>
      <div className="font-serif text-2xl font-semibold text-sky-800 mb-2">
        {sel.formula}
      </div>
      <div className="text-sm text-slate-600 leading-relaxed">{sel.reason}</div>
      <div className="mt-3 grid grid-cols-2 gap-2 text-xs">
        <Meta label="Avg K" value={`${data.avg_k} D`} />
        <Meta label="Corneal cyl" value={`${data.corneal_astigmatism} D`} />
      </div>
    </div>
  );
}

function Meta({ label, value }) {
  return (
    <div className="rounded-md bg-slate-50 border border-slate-200 px-3 py-2">
      <div className="text-[10px] uppercase tracking-wider text-slate-500">{label}</div>
      <div className="font-mono text-sm text-slate-800">{value}</div>
    </div>
  );
}

export default function FormulaCard({ result }) {
  return (
    <Card className="p-5 sm:p-6 border-slate-200" data-testid="formula-card">
      <div className="flex items-center gap-2 mb-4">
        <GitBranch className="w-5 h-5 text-sky-700" />
        <h2 className="font-serif text-2xl font-semibold tracking-tight">Formula Decision Engine</h2>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <EyeFormula side="OD (Right)" data={result.od} />
        <EyeFormula side="OS (Left)" data={result.os} />
      </div>
      {result.warnings?.length > 0 && (
        <div className="mt-4 text-sm text-amber-800 bg-amber-50 border border-amber-200 rounded-md p-3">
          {result.warnings.join(" · ")}
        </div>
      )}
    </Card>
  );
}
